import * as THREE from 'three';

function configureTexture(
   texture,
   {
      colorSpace = THREE.NoColorSpace,
      flipY = false,
      repeat = null,
      wrapRepeat = false,
   } = {},
) {
   texture.colorSpace = colorSpace;
   texture.flipY = flipY;

   if (repeat) {
      texture.wrapS = THREE.RepeatWrapping;
      texture.wrapT = THREE.RepeatWrapping;
      texture.repeat.set(...repeat);
   }

   // Enable wrapping even without initial repeat (for shader-controlled repeats)
   if (wrapRepeat) {
      texture.wrapS = THREE.RepeatWrapping;
      texture.wrapT = THREE.RepeatWrapping;
   }

   return texture;
}

export function loadTextures(assetUrl) {
   const loader = new THREE.TextureLoader();
   const load = (path, options) =>
      configureTexture(loader.load(assetUrl(path)), options);

   return {
      mudWallBaseColor: load(
         'textures/mud_wall_center/brown_mud_03_diff_1k.jpg',
         { colorSpace: THREE.SRGBColorSpace, flipY: true, repeat: [15, 15] },
      ),
      mudWallNormal: load(
         'textures/mud_wall_center/brown_mud_03_nor_gl_1k.png',
         { repeat: [15, 15] },
      ),
      mudWallSpecular: load(
         'textures/mud_wall_center/brown_mud_03_spec_1k.png',
         { repeat: [15, 15] },
      ),
      concreteBaseColor: load(
         'textures/concreteLiquid/Concrete_Floor_tk4lcgjcw_1K_BaseColor.jpg',
         { colorSpace: THREE.SRGBColorSpace },
      ),
      concreteNormal: load(
         'textures/concreteLiquid/Concrete_Floor_tk4lcgjcw_1K_Normal.jpg',
      ),
      concreteRoughness: load(
         'textures/concreteLiquid/Concrete_Floor_tk4lcgjcw_1K_Roughness.jpg',
      ),
      sandBaseColor: load(
         'textures/PileOfSand/Industrial_Construction_Pile_Sand_M_01_xgilfat_Low_1K_BaseColor.jpg',
         { colorSpace: THREE.SRGBColorSpace, repeat: [1, 1] },
      ),
      sandNormal: load(
         'textures/PileOfSand/Industrial_Construction_Pile_Sand_M_01_xgilfat_Low_1K_Normal.jpg',
         { repeat: [1, 1] },
      ),
      sandRoughness: load(
         'textures/PileOfSand/Industrial_Construction_Pile_Sand_M_01_xgilfat_Low_1K_Roughness.jpg',
         { repeat: [1, 1] },
      ),
      streetGravelBaseColor: load(
         'textures/street/Gravel_Ground_vl1oabbfw_1K_BaseColor.jpg',
         {
            colorSpace: THREE.SRGBColorSpace,
            wrapRepeat: true,
            repeat: [3.4, 3.4],
         },
      ),
      streetGravelNormal: load(
         'textures/street/Gravel_Ground_vl1oabbfw_1K_Normal.jpg',
         { wrapRepeat: true, repeat: [3.4, 3.4] },
      ),
      streetGravelRoughness: load(
         'textures/street/Gravel_Ground_vl1oabbfw_1K_Roughness.jpg',
         { wrapRepeat: true, repeat: [3.4, 3.4] },
      ),
      grassBaseColor: load('textures/gras/grasTexture_color.jpg', {
         colorSpace: THREE.SRGBColorSpace,
         wrapRepeat: true,
         repeat: [2, 2],
      }),
      grassNormal: load('textures/gras/grasTexture_normal.jpg', {
         wrapRepeat: true,
         repeat: [2, 2],
      }),
      grassRoughness: load('textures/gras/grasTexture_roughness.jpg', {
         wrapRepeat: true,
         repeat: [2, 2],
      }),
      streetStripes: load('textures/street/stripes.png', {
         colorSpace: THREE.SRGBColorSpace,
         wrapRepeat: true,
      }),
      kollektorBaseColor: load('textures/kollektor/fbGreen_Base_color.png', {
         colorSpace: THREE.SRGBColorSpace,
      }),
      kollektorNormal: load('textures/kollektor/fbGreen_Normal.png'),
      kollektorMetalness: load('textures/kollektor/fbGreen_Base_metalness.png'),
      kollektorRoughness: load(
         'textures/kollektor/fbGreen_Specular_roughness.png',
      ),
      kollektorHeight: load('textures/kollektor/fbGreen_Height.png'),
   };
}
